"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initLoginWatcher = initLoginWatcher;
exports.loggedInSuccessfullyWatcher = loggedInSuccessfullyWatcher;
exports.loggedInFailureWatcher = loggedInFailureWatcher;
exports.signInPageLoadedWatcher = signInPageLoadedWatcher;

var _effects = require("redux-saga/effects");

var _actions = require("../actions");

var _marked = /*#__PURE__*/regeneratorRuntime.mark(callTealiumWorker),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(initLoginWatcher),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(loggedInSuccessfullyWatcher),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(loggedInFailureWatcher),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(signInPageLoadedWatcher);

function callTealiumWorker(_ref) {
  var type, payload, error, data;
  return regeneratorRuntime.wrap(function callTealiumWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          type = _ref.type, payload = _ref.payload, error = _ref.error;
          _context.t0 = type;
          _context.next = _context.t0 === _actions.LOGGED_IN_SUCCESSFULLY ? 4 : _context.t0 === _actions.INIT_LOGIN ? 6 : _context.t0 === _actions.LOGIN_ERROR ? 8 : _context.t0 === _actions.SIGN_IN_PAGE_LOADED ? 10 : 12;
          break;

        case 4:
          data = {
            taggingId: {
              taggingId: 'loginSuccessful'
            },
            taggingType: 'view'
          };
          return _context.abrupt("break", 13);

        case 6:
          data = {
            taggingId: {
              taggingId: 'loginClick'
            },
            taggingType: 'link'
          };
          return _context.abrupt("break", 13);

        case 8:
          data = {
            taggingId: {
              taggingId: 'loginError'
            },
            taggingType: 'view',
            taggingValue: {
              error_category: 'Authentication',
              error_description: error,
              error_list: error
            }
          };
          return _context.abrupt("break", 13);

        case 10:
          data = {
            taggingId: {
              taggingId: 'loginStart'
            },
            taggingType: 'view'
          };
          return _context.abrupt("break", 13);

        case 12:
          return _context.abrupt("break", 13);

        case 13:
          _context.next = 15;
          return (0, _effects.put)((0, _actions.callTealium)(data));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function initLoginWatcher() {
  return regeneratorRuntime.wrap(function initLoginWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_actions.INIT_LOGIN, callTealiumWorker);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function loggedInSuccessfullyWatcher() {
  return regeneratorRuntime.wrap(function loggedInSuccessfullyWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.takeEvery)(_actions.LOGGED_IN_SUCCESSFULLY, callTealiumWorker);

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}

function loggedInFailureWatcher() {
  return regeneratorRuntime.wrap(function loggedInFailureWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(_actions.LOGIN_ERROR, callTealiumWorker);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}

function signInPageLoadedWatcher() {
  return regeneratorRuntime.wrap(function signInPageLoadedWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.takeEvery)(_actions.SIGN_IN_PAGE_LOADED, callTealiumWorker);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}